import { observer } from "mobx-react-lite";
import useAddLeadNoteValidationSchema from "../../hooks/useAddLeadNoteValidationSchema";
import useLeadNoteCreate from "../../hooks/useLeadNoteCreate";
import AddNote from "../AddNote";

function AddLeadNote({ leadId }: { leadId: number }) {
    const createLeadNote = useLeadNoteCreate();
    const validationSchema = useAddLeadNoteValidationSchema();

    return (
        <AddNote
            onSubmitNote={(text) => createLeadNote(leadId, text)}
            validationSchema={validationSchema}
        />
    );
}

export default observer(AddLeadNote);
